import Vue from 'vue';
import Vuex from 'vuex';
import { AUTH_MOBILE_REQUEST, AUTH_MOBILE_SUCCESS, AUTH_MOBILE_ERROR } from '@/actions';
import { AUTH_OTP_REQUEST, AUTH_OTP_SUCCESS, AUTH_OTP_ERROR } from '@/actions';
import { ERROR_GEN_NETWORK } from '@/actions';
import { AUTH_LOGOUT } from '@/actions';
import { authService } from '@/services/auth.service';
Vue.use(Vuex);
const userToken = 'user-token';
export default new Vuex.Store({
    state: {
        token: localStorage.getItem(userToken) || '',
        status: '',
        hasLoadedOnce: false,
        errorCode: 0,
        errorMessage: 'Internal Service Error?',
    },
    getters: {
        isAuthenticated: (state) => (state.token !== '') ? true : false,
        authStatus: (state) => state.status,
        errorCode: (state) => state.errorCode,
        errorMessage: (state) => state.errorMessage,
    },
    mutations: {
        [AUTH_MOBILE_REQUEST]: (state) => { state.status = 'loading'; },
        [AUTH_MOBILE_SUCCESS]: (state, token) => {
            state.status = 'otp';
            state.token = token;
            state.hasLoadedOnce = true;
        },
        [AUTH_MOBILE_ERROR]: (state) => { state.status = 'error'; state.hasLoadedOnce = true; },
        [AUTH_OTP_REQUEST]: (state) => { state.status = 'loading'; },
        [AUTH_OTP_SUCCESS]: (state, token) => {
            state.status = 'success';
            state.token = token;
            state.hasLoadedOnce = true;
        },
        [AUTH_OTP_ERROR]: (state) => { state.status = 'error'; state.hasLoadedOnce = true; },
        [AUTH_LOGOUT]: (state) => { state.token = ''; },
        [ERROR_GEN_NETWORK]: (state, data) => {
            state.errorCode = data.code;
            state.errorMessage = data.message;
            // console.log('store->mutations: ', data);
        },
    },
    actions: {
        [AUTH_MOBILE_REQUEST]: ({ commit, dispatch }, model) => {
            // tslint:disable-next-line:no-shadowed-variable
            return new Promise((resolve, reject) => {
                commit(AUTH_MOBILE_REQUEST);
                authService.authMobile(model)
                    .then((resp) => {
                    commit(AUTH_MOBILE_SUCCESS, resp);
                    resolve(resp);
                })
                    .catch((err) => {
                    commit(AUTH_MOBILE_ERROR, err);
                    reject(err);
                });
            });
        },
        [AUTH_OTP_REQUEST]: ({ commit, dispatch }, model) => {
            // tslint:disable-next-line:no-shadowed-variable
            return new Promise((resolve, reject) => {
                commit(AUTH_OTP_REQUEST);
                authService.authOtp(model)
                    .then((resp) => {
                    const token = resp.data.token;
                    localStorage.setItem('user-token', token);
                    commit(AUTH_OTP_SUCCESS, token);
                    resolve(resp);
                })
                    .catch((err) => {
                    commit(AUTH_OTP_ERROR, err);
                    localStorage.removeItem('user-token');
                    reject(err);
                });
            });
        },
        [AUTH_LOGOUT]: ({ commit, dispatch }) => {
            // tslint:disable-next-line:no-shadowed-variable
            return new Promise((resolve, reject) => {
                commit(AUTH_LOGOUT);
                localStorage.removeItem(userToken);
                resolve();
            });
        },
        [ERROR_GEN_NETWORK]: ({ commit, dispatch }, data) => {
            // tslint:disable-next-line:no-shadowed-variable
            return new Promise((resolve, reject) => {
                // console.log('store->action: ', data);
                commit(ERROR_GEN_NETWORK, data);
                resolve(data);
            });
        },
    },
});
//# sourceMappingURL=store.js.map